import { useState } from "react";
import {
  LeftContent,
  StyledImage,
  UploadActions,
  UploadImageContainer,
  DeleteButton,
  CheckboxText,
  CheckboxContainer,
  ContainerWrapper,
  CropButton,
  CheckboxContainerColumn,
} from "./ImageToVideo.styles";
import SelectImageButton from "../SelectImageButton/SelectImageButton";
import UploadAdButton from "../PlayboxAdCard/UploadAdButton";

import { selectSelectedCollection } from "../../store/slices/model/slice";

import { ReactComponent as CropIcon } from "../../assets/icons/crop.svg";
import { useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { isImageOutput } from "../../utils/utils";
import LottieIcon from "../../components/LottieIcon/LottieIcon";
import checkboxAnimation from "../../assets/animations/radioButton.json";
import deleteAnimation from "../../assets/animations/trash.json";
// import TermsCheckboxComponent from "../TermsCheckboxComponent/TermsCheckboxComponent";

const ImageToVideo = ({
  setIsOpenCropModal,
  setUploadedImage,
  uploadedImage,
  generateContainer,
  setNudifyEnabled,
  // agreeTos,
  // handleCheckboxClick,
  // showOutline,
  // shouldShake,
  uploadedImageRef,
  nudifyEnabled,
  upscaleEnabled,
  setUpscaleEnabled,
  onOpenGalleryModal,
}) => {
  const collection = useSelector(selectSelectedCollection);

  const isMobile = useMediaQuery({ maxWidth: 768 });

  const [widthDifference, setWidthDifference] = useState(null);
  const [hideImageContainer, setHideImageContainer] = useState(null);

  const checkWidthDifference = () => {
    setTimeout(() => {
      if (uploadedImageRef.current) {
        const imageWidth = uploadedImageRef.current.offsetWidth;
        const parentWidth = uploadedImageRef.current.parentElement.offsetWidth;
        const difference = parseInt((parentWidth - imageWidth) / 2);

        const maxDifference = isMobile ? 30 : 35;

        const hide = difference > 0 && difference < maxDifference;

        setWidthDifference(hide ? difference : 0);
        setHideImageContainer(hide);
      }
    }, 0);
  };

  if (!collection) {
    return null;
  }

  const input = collection.input;

  return (
    <ContainerWrapper>
      <LeftContent>
        <UploadImageContainer>
          {uploadedImage && (
            <DeleteButton
              $shift={widthDifference}
              onClick={() => {
                setUploadedImage(null);
              }}
            >
              <LottieIcon
                animationData={deleteAnimation}
                trigger="hover"
                size={24}
              />
            </DeleteButton>
          )}
          {uploadedImage && (
            <CropButton
              $shift={widthDifference}
              onClick={() => {
                setIsOpenCropModal(true);
              }}
            >
              <CropIcon />
            </CropButton>
          )}

          <StyledImage
            ref={uploadedImageRef}
            src={
              uploadedImage?.url ||
              input.image.resizedImage.url ||
              input.image.url
            }
            $hideImageContainer={hideImageContainer || !uploadedImage}
            onLoad={checkWidthDifference}
          />

          <UploadActions>
            <UploadAdButton />
            <SelectImageButton
              onClick={() => onOpenGalleryModal?.()}
              style={{ width: "100%" }}
            />
          </UploadActions>
        </UploadImageContainer>
        {!isImageOutput(collection.modelName) && (
          <CheckboxContainerColumn>
            <CheckboxContainer
              onClick={() => {
                setNudifyEnabled(!nudifyEnabled);
              }}
            >
              <LottieIcon
                animationData={checkboxAnimation}
                trigger="toggle-reverse"
                isActive={nudifyEnabled}
                speed={2}
                onActiveChange={() => {
                  setNudifyEnabled(!nudifyEnabled);
                }}
                onClick={() => {
                  setNudifyEnabled(!nudifyEnabled);
                }}
                size={24}
                strokeColor={"#2877d9"}
              />
              <CheckboxText>Nudify First</CheckboxText>
            </CheckboxContainer>
            <CheckboxContainer
              onClick={() => {
                setUpscaleEnabled(!upscaleEnabled);
              }}
            >
              <LottieIcon
                animationData={checkboxAnimation}
                trigger="toggle-reverse"
                isActive={upscaleEnabled}
                speed={2}
                onActiveChange={() => {
                  setUpscaleEnabled(!upscaleEnabled);
                }}
                onClick={() => {
                  setUpscaleEnabled(!upscaleEnabled);
                }}
                size={24}
                strokeColor={"#2877d9"}
              />
              <CheckboxText>Enhance Photo</CheckboxText>
            </CheckboxContainer>
          </CheckboxContainerColumn>
        )}

        {generateContainer}
        {/* <TermsCheckboxComponent
          handleCheckboxClick={handleCheckboxClick}
          agreeTos={agreeTos}
          shouldShake={shouldShake}
          showOutline={showOutline}
          offMarginTop
          offHorizontalMargin
        /> */}
      </LeftContent>
    </ContainerWrapper>
  );
};

export default ImageToVideo;
